import _ from 'lodash';

function elementTopPosition(y, offset = 0, unit = 'px') {
  // HACK: change to dynamic window height
  let local = '';
  // if ( unit === '%' ) {
  // BUG : bez sensu konwersja % na % ???
  // local = _.round( ( y + offset ) * 100 / 1080, 2 ) + '%';
  // } else {
  if (!_.isFinite(parseInt(y))) {
    return undefined;
  }
  local = [parseInt(y) + offset, unit].join('');
  // }
  return local;
}

function elementLeftPosition(x, offset = 0, unit = 'px') {
  // HACK: change to dynamic window width
  let local = '';
  // if ( unit === '%' ) {
  //   local = _.round( ( x + offset ) * 100 / 1920, 2 ) + '%';
  // } else {

  if (!_.isFinite(parseInt(x))) {
    return undefined;
  }
  local = [parseInt(x) + offset, unit].join('');

  // }
  return local;
}

function elementWidth(width, unit = 'px') {
  let local = '';
  // HACK: change to dynamic window width
  // if ( /%$/.test( width ) || unit === '%' ) {
  // local = _.round( width * 100 / 1920, 2 ) + '%';
  // } else {
  if (!_.isFinite(parseInt(width))) {
    return undefined;
  }
  local = [width, unit].join('');
  // local = parseInt( /[0-9.*]+/.exec( width )[ 0 ] );
  // }
  return local;
}

function elementHeight(height, unit = 'px') {
  let local = '';
  // HACK: change to dynamic window height
  // if ( /%$/.test( height ) || unit === '%' ) {
  // local = _.round( height * 100 / 1080, 2 ) + '%';
  // } else {
  if (!_.isFinite(parseInt(height))) {
    return undefined;
  }
  local = [height, unit].join('');
  // local = parseInt( /[0-9.*]+/.exec( height )[ 0 ] );
  // }
  // // console.log( 'local', local );

  return local;
}

export { elementTopPosition, elementLeftPosition, elementWidth, elementHeight };
